// extracted by mini-css-extract-plugin
module.exports = {"sharePopover":"ao","shareText":"ap","show":"aq"};